import Config from '@skin_config';

export const getCasinoGameURL = (game, userInfo, lang, playType = 'real') => {
  if (!game.TableId && !game.types.realMode && !game.types.viewMode && !game.types.funMode) return;

  const authData = JSON.parse(sessionStorage.getItem('authData'));
  const casinoToken = encodeURIComponent(
    userInfo.loggedIn ? userInfo.authData.auth_token : authData.token,
  );
  const queryParams = `token=${casinoToken}&platformType=2&iscashdesk=${!userInfo.loggedIn}`;

  if (game.TableId) {
    return game.Limits[0].OpenUrl.startsWith('?')
      ? `${Config.liveCasino.tableUrlForBetOnPoker}/${game.Limits[0].OpenUrl}&${queryParams}`
      : `${Config.liveCasino.tableURL + game.Limits[0].OpenUrl}/?${queryParams}`;
  }

  return `${Config.casino.urlPrefix}/${Config.casino.terminalLauncherPrefix}?gameid=${game.extearnal_game_id}&openType=${playType}&provider=${game.provider
  }&=activeGroupId=${Config.liveCasinoActiveGroup[game.name]
  }&language=${Config.main.availableLanguages[lang]?.short?.toLowerCase()}&partnerid=${authData.pid
  }&devicetypeid=6&${queryParams}`;
};

export const updateLastPlayedGames = (activeGame) => {
  const lastCasinoGames = JSON.parse(sessionStorage.getItem('lastCasinoGames')) || [];

  if (lastCasinoGames.find((game) => game.id === activeGame.game.id)) return;

  if (lastCasinoGames.length === Config.casino.games.lastPlayedLimit) {
    lastCasinoGames.pop();
  }
  if (activeGame.routePath !== '/liveCasino') {
    sessionStorage.setItem('lastCasinoGames', JSON.stringify([activeGame.game, ...lastCasinoGames]));
  }
};
